import { makeStyles } from '@material-ui/styles';

const CONTROL_BAR_HEIGHT = 132;

export default makeStyles(theme => ({
  paper: {
    height: '100%',
    display: 'flex',
    justifyContent: 'space-between',
  },
  loanOfficersBox: {
    position: 'relative',
    height: '100%',
    minWidth: 370,
    width: 370,
    borderRight: `1px solid ${theme.palette.colors.border}`,
  },
  loanOfficerInfoBox: {
    position: 'relative',
    height: '100%',
    maxWidth: '430px',
    minWidth: '430px',
    borderLeft: `1px solid ${theme.palette.colors.border}`,
  },
  chatBox: {
    minWidth: 500,
    width: '100%',
  },
  chatControlBar: {
    marginBottom: 20,
    height: CONTROL_BAR_HEIGHT,
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  controlButton: {
    height: 40,
    width: 200,
    marginTop: theme.spacing(2),
  },
  emptyChatBox: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100%',
  },
}));



// WEBPACK FOOTER //
// ./src/components/BuyerMessages/components/DesktopMessages/useStyles.js